import React, { useEffect } from 'react';
import { reloadDocument } from './navigation.js';

/**
 * /pay reached by a client-side route change inside the full app.
 *
 * The payment page must not run inside this tree (telemetry, default-axios
 * interceptors, session providers — see PayRoot.jsx). Loading the document
 * again lets main.jsx start the minimal tree instead; a fragment on the URL
 * is picked up there.
 */
export default function PayBoundary() {
  useEffect(() => {
    reloadDocument();
  }, []);
  return <p className="gc-visually-hidden" data-testid="pay-boundary">Opening the payment page…</p>;
}
